import { createSelector } from 'reselect';

export const selectRegistrationsSlice = state => state.registrations;

export const selectRegistrations = createSelector(
  selectRegistrationsSlice,
  slice => slice.registrations
);
export const registrationsLoaded = createSelector(
  selectRegistrationsSlice,
  slice => slice.registrationsLoaded
);
export const selectActiveRegistration = createSelector(
  selectRegistrationsSlice,
  slice => slice.activeRegistration
);
export const registrationCreating = createSelector(
  selectRegistrationsSlice,
  slice => slice.isCreating
);
export const registrationsMeta = createSelector(
  selectRegistrationsSlice,
  slice => slice.meta
);
export const registrationsFilters = createSelector(
  selectRegistrationsSlice,
  slice => slice.filters
);
export const registrationsIsCreating = createSelector(
  selectRegistrationsSlice,
  slice => slice.isCreating
);
export const registrationsIsUpdating = createSelector(
  selectRegistrationsSlice,
  slice => slice.isUpdating
);
export const registrationsIsDeleting = createSelector(
  selectRegistrationsSlice,
  slice => slice.isDeleting
);
